import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=bd7fef66&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7fef66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd7fef66')) {
      api.createRecord('bd7fef66', component.options)
    } else {
      api.reload('bd7fef66', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=bd7fef66&scoped=true&", function () {
      api.rerender('bd7fef66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nRp41j0RQTsn/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports